import { render, staticRenderFns } from "./BuildingShowConfigurationsTab.vue?vue&type=template&id=2647b669"
import script from "./BuildingShowConfigurationsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowConfigurationsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports